import { render, staticRenderFns } from "./point-list.vue?vue&type=template&id=2835c746&scoped=true&"
import script from "./point-list.vue?vue&type=script&lang=ts&"
export * from "./point-list.vue?vue&type=script&lang=ts&"
import style0 from "./point-list.vue?vue&type=style&index=0&id=2835c746&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2835c746",
  null
  
)

export default component.exports